<div class="" fxLayout="column" fxLayoutAlign="start center">
  <ng-container *ngIf="data.tipo == 'Recordatorios'">
    <ng-container *ngIf="data.fechasRecordatorios.length > 0">
      <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TIUTLOLISTA' | translate}}</h2>
      <mat-dialog-content class="mat-typography">
        <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORA' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+data.instituto | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
        <mat-list class="tac">
          <mat-list-item *ngFor="let fecha of data.fechasRecordatorios; last as last">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{fecha|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha|date:'z':offsetPipe:idiomaActual}})</h4>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-dialog-content>
    </ng-container>
    <ng-template *ngIf="data.fechasRecordatorios.length == 0">
      <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
    </ng-template>
  </ng-container>

  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'SHEDULE2_0.CERRAR' | translate}}
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</div>
